import { Directive } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Directive()
export abstract class AddConnectionBaseComponent extends BaseComponent {
  constructor(public userService: UserService) {
    super(userService);
  }
}
